import React from 'react'
import { Article } from 'components/Sections/Article'
import { useTranslation } from 'hooks/useTranslation'
import { InformationCollapse, InformationCollapseType } from 'components/InformationCollapse'
import { Title, FaqsRoot } from './Faqs.styles'
import Link from 'next/link'
export const Faqs: React.FC = () => {
  const { t } = useTranslation()

  const faqItems: InformationCollapseType[] = [
    {
      label: 'faqs:raw-benefits.how-soon-benefits.question',
      description: 'faqs:raw-benefits.how-soon-benefits.answer',
    },
    {
      label: 'faqs:raw-benefits.is-raw-good.question',
      description: 'faqs:raw-benefits.is-raw-good.answer',
    },
    {
      label: 'faqs:raw-benefits.risks-of-raw.question',
      description: 'faqs:raw-benefits.risks-of-raw.answer',
    },
    {
      label: 'faqs:raw-benefits.nutritional-deficiencies.question',
      description: 'faqs:raw-benefits.nutritional-deficiencies.answer',
    },
    {
      label: 'faqs:raw-benefits.how-to-introduce-diet.question',
      description: 'faqs:raw-benefits.how-to-introduce-diet.answer',
    },
    {
      label: 'faqs:raw-benefits.can-all-dogs-eat-raw.question',
      description: 'faqs:raw-benefits.can-all-dogs-eat-raw.answer',
    },
    {
      label: 'faqs:raw-benefits.are-there-health-risks.question',
      description: 'faqs:raw-benefits.are-there-health-risks.answer',
    },
    {
      label: 'faqs:raw-benefits.common-mistakes.question',
      description: 'faqs:raw-benefits.common-mistakes.answer',
    },
  ]

  return (
    <FaqsRoot>
      <Article background="white">
        <Title id="raw-benefits-faqs-title">{t('faqs:raw-benefits.title')}</Title>
        <InformationCollapse transComponents={{ Link: <Link href='/meal-plan'/> }} className="raw-benefits-faqs" v2 infoList={faqItems} />
      </Article>
    </FaqsRoot>
  )
}

Faqs.displayName = 'RawBenefitsFaqs'
